import restaurantInstance from '../../../instance'
import restaurantModalLoginInstance from '../../../modalLoginInstance'

const updateTableCart = (tableId, data, hasModalLogin = true) => {
	return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
		.post(`/tables/${tableId}/orders/updateCart`, data)
}

export default updateTableCart
